<template>
    <div>
      <CreateContactComponent />
    </div>
  </template>
  
  <script>
  import CreateContactComponent from '@/components/CreateContactComponent.vue';
  
  export default {
    components: {
        CreateContactComponent,
    },
  };
  </script>